module.exports = __webpack_public_path__ + "img/the-qi_banner.cf17361b.jpg";